import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-choosing-ifp',
    templateUrl: './choosing-ifp.component.html',
    styleUrls: ['./choosing-ifp.component.scss']
})
export class ChoosingIfpComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titleService: Title,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Choosing the Right Interactive Flat Panel for Your School | IFP Buying Guide India');
        this.meta.updateTag({
            name: 'description',
            content: 'Planning to buy an Interactive Flat Panel for your school? Learn key features, size selection, software needs, and expert tips to choose the best IFP for classrooms.'
        });
        this.meta.updateTag({
            name: 'keywords',
            content: 'interactive flat panel for schools, IFP buying guide India, smart classroom display, best interactive panel for classroom, smart classroom technology India, digital classroom solutions, NEP 2020 smart classroom, interactive display for education'
        });
    }

}
